import { helper } from '@ember/component/helper';

export function toInt([input]) {
  return Number.parseInt(input, 10);
}

export default helper(toInt);
